import firebase from '@firebase/app';
require('@firebase/auth');
require('@firebase/firestore');
import config from '../config/config';
export default !firebase.apps.length ? firebase.initializeApp(config.firebase.config) : firebase.app();
export const Auth = firebase.auth();

const db = firebase.firestore();
// db.settings({
// 	timestampsInSnapshots: true
// });
export const DB = db;
